import { messages } from "../lib/messages";
import { FullScreenMessage } from "./FullScreenMessage";

/**
 * ShopUnavailableScreen — магазин не в статусе active (docs/07-miniapp-ux.md §2.1).
 * Кнопку «Написать менеджеру» из ТЗ не показываем: на этом шаге ещё нет GET /shop
 * с manager_url — ошибка 409 приходит уже на POST /auth (docs/11-backlog.md).
 */
export function ShopUnavailableScreen() {
  return (
    <FullScreenMessage
      testId="shop-unavailable"
      title={messages.shopUnavailable}
      description={messages.shopUnavailableHint}
    />
  );
}
